// extracted by mini-css-extract-plugin
export var ad_wrapper = "styles-module--ad_wrapper--1c706";